import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Close, Logo } from "@vfit/ui/icons";
import { fonts, pxToFontSize, pxToLineHeight, pxToRem } from "@vfit/shared/themes";
import { AccordionNavigationType } from "@vfit/shared/models";
import { AccordionNavigation } from "@vfit/shared/components";
import { handlerClickMenu } from "../../../header.utils";
import Footer from "../Footer/footer";
import { AccordionContainer, CloseBtn, LogoOverlay, OverlayContainer, Top } from "./overlayMenu.style";
var accordionNavigationConfig = {
    fontFamily: fonts.light,
    fontSize: pxToFontSize(20),
    fontWeight: 400,
    lineHeight: pxToLineHeight(20, 28).toString(),
    iconSize: 24,
    fontFamilyLinks: fonts.regular,
    fontSizeLinks: pxToFontSize(14),
    fontWeightLinks: 400,
    lineHeightLiks: pxToLineHeight(14, 18).toString(),
    marginLeftLink: pxToRem(48),
    highlightColor: "#e60000",
    enableHighlight: true,
    fontFamilySecondLevel: fonts.regular,
    fontSizeSecondLevel: pxToFontSize(16),
    fontWeightSecondLevel: 400,
    lineHeightSecondLevel: pxToLineHeight(16, 20).toString(),
    iconSizeSecondLevel: 20,
    marginLeftSecondLevel: pxToRem(4)
};
var OverlayMenu = function(param) {
    var _header = param.header, head = _header.head, body = _header.body, onTrack = param.onTrack, setIsMenuOpen = param.setIsMenuOpen, isMenuOpen = param.isMenuOpen;
    var menuType = body.menuType;
    return /*#__PURE__*/ _jsxs(OverlayContainer, {
        className: isMenuOpen,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs(Top, {
                        children: [
                            /*#__PURE__*/ _jsx(LogoOverlay, {
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "https://www.google.it",
                                    children: /*#__PURE__*/ _jsx(Logo, {})
                                })
                            }),
                            /*#__PURE__*/ _jsx(CloseBtn, {
                                "aria-label": "close",
                                onClick: function() {
                                    return setIsMenuOpen("fade-out");
                                },
                                children: /*#__PURE__*/ _jsx(Close, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(AccordionContainer, {
                        children: /*#__PURE__*/ _jsx(AccordionNavigation, {
                            onTrack: onTrack,
                            handlerClickMenu: handlerClickMenu,
                            links: menuType,
                            config: accordionNavigationConfig,
                            accordionNavigationType: AccordionNavigationType.MENU
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Footer, {
                customerType: head.customerType,
                otherInfo: head.otherInfo,
                userInfo: head.userInfo,
                onTrack: onTrack
            })
        ]
    });
};
export default OverlayMenu;
